/**
 * Pauta connector — first real connector architecture (Sprint 3.2).
 * Auto-registers on ConnectorFactory when this module is imported.
 */

import { connectorFactory } from '@/modules/connector-sdk'

import { PautaConnector } from './PautaConnector'
import { PAUTA_CONNECTOR_ID } from './PautaTypes'

export * from './PautaTypes'
export * from './PautaErrors'
export * from './PautaParser'
export * from './PautaMapper'
export * from './PautaConnector'

/** Automatic registration — no hardcoded supplier logic outside Connector SDK. */
connectorFactory.register(PAUTA_CONNECTOR_ID, PautaConnector)
